import { ClientType } from '@maru44/huntre-utils/src/models/client'
import { DEFAULT_MAX_GROUPS, type User } from '@maru44/huntre-utils/src/models/user'
import { getData } from '@maru44/huntre-utils/src/utils/data'
import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore'
import { useCallback } from 'react'
import { NotFoundError, ValidationError } from 'src/utils/error'
import { firestore } from 'src/utils/firebase'
import useSWR from '../useSWR'

export const useUser = (id: string) => {
  const getUser = useSWR(
    [`/users/${id}`, id],
    async () => {
      const ref = doc(firestore, `users/${id}`)
      const snap = await getDoc(ref)
      if (!snap.exists) {
        throw new NotFoundError('user', id)
      }
      const data = getData<User>(snap)

      if (!data) {
        throw new NotFoundError('user', id)
      }

      return { data, ref }
    },
    {
      disabled: !id,
    },
  )

  const ensureCanJoinAnotherGroup = useCallback(async (userId: string) => {
    const ref = doc(firestore, `users/${userId}`)
    const snap = await getDoc(ref)
    if (!snap.exists) {
      throw new NotFoundError('user', userId)
    }
    const user = getData<User>(snap)
    const max = user.maxGroups ?? DEFAULT_MAX_GROUPS

    const q = query(collection(firestore, 'clients'), where('clientMemberIds', 'array-contains', userId), where('type', '==', ClientType.Group))
    const groups = await getDocs(q)
    if (groups.size >= max) {
      throw new ValidationError(`所属できるグループ数の上限 (${max}) に達しています`)
    }
  }, [])

  return { getUser, ensureCanJoinAnotherGroup }
}
